import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';

const AboutCohortSkeletonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${spacing.base};
  margin: ${spacing.plusHalf};
`;

export const AboutCohortEngagementSkeletonId = 'about-cohort-engagement-skeleton';
export const AboutCohortMovementSkeletonId = 'about-cohort-movement-skeleton';

export const AboutYourCohortSkeleton = () => {
  return (
    <AboutCohortSkeletonContainer>
      <Skeleton data-test={AboutCohortEngagementSkeletonId} width={465} height={305} />
      <Skeleton data-test={AboutCohortMovementSkeletonId} width={680} height={305} />
    </AboutCohortSkeletonContainer>
  );
};
